


















import AddToCartMixin from '@/product/mixins/addToCartMixin'

export default AddToCartMixin.extend({})
